import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plainsight',
  templateUrl: './plainsight.component.html',
  styleUrls: ['./plainsight.component.scss']
})
export class PlainsightComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/plainsight/plainsight.component.ts